import React from 'react'
import { useNavigate } from 'react-router-dom';

function ShowError() {
    const navigate = useNavigate();
    return <div className='w-full h-screen flex items-center justify-center text-center'>
        <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <p >
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-center text-gray-900 dark:text-white">Please contact server administrator!</h5>
            </p>

            <p onClick={()=>{
                navigate("/")
            }} 
            className="inline-flex items-center px-3 cursor-pointer py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Go To Home Page
                <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 5h12m0 0L9 1m4 4L9 9" />
                </svg>
            </p>
        </div>

    </div>
}

export default ShowError